import { StaticBaseUrl } from './Constants';

export default {

    getIconAttribute(iconid, styleid){
        let s = styleid > 1 ? '_'+styleid : ''; 
        return StaticBaseUrl +'/icons/attributes/'+iconid+s+'.svg';
    },

    getIconAllergen(iconid, styleid){
        let s = styleid > 1 ? '_'+styleid : ''; 
        return StaticBaseUrl +'/icons/allergens/'+iconid+s+'.svg';
    },

    getIconCat(url){
        return StaticBaseUrl +url;
    },

    

    getDishImage(url){
        return StaticBaseUrl +url;
    },
    

    getLogo(url){
        return StaticBaseUrl +url;
    },
}